<template>
  <div class="pt-panel calc-table-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">{{ oneTitle }}</h2>
        <p class="pt-subtitle">水资源配置方案 · 供需分析</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-scroll">
      <div v-if="loading" class="pt-loading">
        <div class="pt-spinner"></div>
        <p class="pt-loading-text">数据加载中...</p>
      </div>

      <div v-else class="pt-flex-table">
        <div class="pt-flex-table-header">
          <div class="pt-flex-table-cell">对象</div>
          <div class="pt-flex-table-cell">古贤配水量</div>
          <div class="pt-flex-table-cell">古贤供水量</div>
          <div class="pt-flex-table-cell">面积（万亩）</div>
        </div>
        <div
            class="pt-flex-table-row"
            v-for="(item, index) in tableData[activeTab]"
            :key="index"
            :class="{ 'pt-row-warn': isUnbalanced(item) }"
            @click="goUnbalance(item)"
        >
          <div class="pt-flex-table-cell">{{ item.obj }}</div>
          <div class="pt-flex-table-cell">{{ item.pei }}</div>
          <div class="pt-flex-table-cell">{{ item.gong }}</div>
          <div class="pt-flex-table-cell">{{ item.area }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "calcTable",
  data() {
    return {
      oneTitle: "水资源配置方案",
      tabs: ["方案1", "方案2", "方案3"],
      activeTab: "方案1",
      loading: true,
      tableData: {
        "方案1": [
          { obj: "9个城市", pei: "14860", gong: "16346", area: "", note: "" },
          { obj: "8个县61个镇村镇生活", pei: "4612", gong: "5073", area: "", note: "" },
          { obj: "12个工业园区", pei: "14099", gong: "15509", area: "", note: "" },
          { obj: "东雷1", pei: "35544", gong: "35544", area: "126.57", note: "替代" },
          { obj: "东雷2", pei: "25779", gong: "25779", area: "85.50", note: "替代" },
          { obj: "石堡川", pei: "3211", gong: "3211", area: "16.40", note: "补灌" },
          { obj: "交口", pei: "20432", gong: "15320", area: "65.00", note: "供需不平衡" },
          { obj: "洛惠渠", pei: "8684", gong: "8684", area: "34.30", note: "补灌" },
          { obj: "桃曲坡", pei: "6818", gong: "6818", area: "23.12", note: "补灌" },
          { obj: "其他已成型灌区", pei: "17442", gong: "17442", area: "63.13", note: "补灌" },
          { obj: "大荔新建灌溉面积", pei: "3672", gong: "3672", area: "19.05", note: "新建" },
          { obj: "合阳新建灌溉面积", pei: "3229", gong: "3229", area: "14.14", note: "新建" },
          { obj: "澄城新建灌溉面积", pei: "3618", gong: "3618", area: "19.76", note: "新建" },
          { obj: "富平新建灌溉面积", pei: "6033", gong: "6033", area: "26.10", note: "新建" },
          { obj: "蒲城新建灌溉面积", pei: "7503", gong: "7503", area: "32.46", note: "新建" },
          { obj: "白水新建灌溉面积", pei: "4324", gong: "4324", area: "23.27", note: "新建" },
          { obj: "韩城新建灌溉面积", pei: "751", gong: "751", area: "3.50", note: "新建" },
          { obj: "宜川新建灌溉面积", pei: "1906", gong: "1906", area: "10.00", note: "新建" },
        ],
        "方案2": [],
        "方案3": [],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    },
    isUnbalanced(item) {
      if (item.obj == '交口') {
        return true
      } else {
        return false
      }
    },
    goUnbalance(item) {
      if (item.obj == '交口') {
        this.$emit("unbalance");
      }
    }
  },
};
</script>

<style scoped>
.calc-table-panel {
  width: 45%;
  height: 65%;
  position: absolute;
  overflow-y: auto;
  max-height: 65%;
  left: 30%;
  top: 200px;
}

.pt-row-warn {
  background: rgba(250, 204, 21, 0.1) !important;
  animation: pt-flicker 1.8s infinite alternate;
}

.pt-row-warn:hover {
  background: rgba(250, 204, 21, 0.16) !important;
}

@keyframes pt-flicker {
  0% { opacity: 0.85; }
  100% { opacity: 1; }
}
</style>
